import React, { FC } from 'react';
import { ReactComponent as EmptyMessagesIcon } from 'src/assets/images/onboarding-trainer/dashboard/messages/empty-messages.svg';
import './DashboardMessagesPlaceholder.scss';

export const DashboardMessagesPlaceholder: FC = () => {
  return (
    <div className="dashboard-messages-placeholder">
      <div className="placeholder-content">
        <div className="placeholder-icon-wrap">
          <EmptyMessagesIcon className="placeholder-icon" />
        </div>
        <h3 className="placeholder-title">Select a conversation</h3>
        <p className="placeholder-subtitle">
          Choose a message, inquiry, or check-in from the left panel to view and reply.
        </p>
      </div>
    </div>
  );
};
